module.exports = __webpack_public_path__ + "static/media/notification.3290b51a.mp3";